




























































































































import { createComponent, ref, Ref, watch, computed } from "@vue/composition-api"
import { getUser, updateUserNotes } from "@/api/users"
import { cancelMembership, removePaymentMethod } from "@/api/purchases"
import { Maybe, User } from "@/generated/graphql"
import ListAppointments from "@/components/admin/appointments-list.vue"
import UserNotes from "@/components/admin/user-notes.vue"
import { formatDateShort, formatPronoun } from "@/utils"

export default createComponent({
  components: {
    ListAppointments,
    UserNotes
  },
  props: {
    id: String
  },
  setup(props, { root }) {
    const user: Ref<Maybe<User>> = ref(null)
    const isRemoving = ref(false)

    watch(async () => {
      user.value = await getUser(props.id)
    })

    const canIssueRefand = computed(() => {
      if (isArtist) {
        return false
      } else if (isManager || isAdmin) {
        return true
      } else {
        return false
      }
    })

    function handleRemoveCC() {
      root.$alert(`${user.value.paymentMethod}.`, "Are you sure you want to remove", {
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        cancelButtonClass: "el-button--cancel",
        callback: actionType => {
          if (actionType === "cancel") return
          handleRemovePaymentMethod()
        }
      })
    }

    async function handleRemovePaymentMethod() {
      try {
        isRemoving.value = true
        await removePaymentMethod({ userId: user.value.id })
        user.value = await getUser(user.value.id)
      } catch (error) {
        root.$alert("Failed to remove credit card", { type: "error" })
        console.log("remove cc error", error)
      } finally {
        isRemoving.value = false
      }
    }

    async function updateNotes (notes) {
      user.value.notes = notes
      let id = user.value.id
      await updateUserNotes({ id, notes })
    }

    const isAdmin = root.$store.getters["auth/isAdmin"]
    const isManager = root.$store.getters["auth/isManager"]
    const isArtist = root.$store.getters["auth/isArtist"]

    async function handleCancelMembership() {
      try {
        const { value } = (await root.$prompt(
          `Are you sure you want to cancel your membership? Membership periods extend for three months after you
          purchased your membership. If you cancel before three months, you will still be charged for any remaining
          months. Your membership will remain usable, but it will not renew after three months. Type CANCEL in
          all caps to cancel your membership.`,
          "Cancel Membership",
          {
            confirmButtonText: "Cancel membership",
            showCancelButton: false,
            inputType: "text",
            inputValidator: value => value === "CANCEL",
            inputErrorMessage: "Type CANCEL in all caps."
          }
        )) as any

        if (value === "CANCEL") {
          const { successful } = await cancelMembership({ id: user.value.membership.id })
          if (successful) {
            user.value = await getUser(props.id)
          }
        }
      } catch {
        // ignore
      }
    }

    return {
      isAdmin,
      isManager,
      isArtist,
      canIssueRefand,
      user,
      isRemoving,
      updateNotes,
      // methods
      handleCancelMembership,
      handleRemoveCC,
      handleRemovePaymentMethod,
      formatDateShort,
      formatPronoun
    }
  }
})
